// 20220112171022
// https://api.github.com/users/mahfod-dev/followers

export default [
	{
		login: 'zendy199x',
		id: 50132805,
		node_id: 'MDQ6VXNlcjUwMTMyODA1',
		avatar_url: 'https://avatars.githubusercontent.com/u/50132805?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/zendy199x',
		html_url: 'https://github.com/zendy199x',
		followers_url: 'https://api.github.com/users/zendy199x/followers',
		following_url:
			'https://api.github.com/users/zendy199x/following{/other_user}',
		gists_url: 'https://api.github.com/users/zendy199x/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/zendy199x/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/zendy199x/subscriptions',
		organizations_url: 'https://api.github.com/users/zendy199x/orgs',
		repos_url: 'https://api.github.com/users/zendy199x/repos',
		events_url: 'https://api.github.com/users/zendy199x/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/zendy199x/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'vincent-souchiere',
		id: 74507135,
		node_id: 'MDQ6VXNlcjc0NTA3MTM1',
		avatar_url: 'https://avatars.githubusercontent.com/u/74507135?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/vincent-souchiere',
		html_url: 'https://github.com/vincent-souchiere',
		followers_url: 'https://api.github.com/users/vincent-souchiere/followers',
		following_url:
			'https://api.github.com/users/vincent-souchiere/following{/other_user}',
		gists_url: 'https://api.github.com/users/vincent-souchiere/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/vincent-souchiere/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/vincent-souchiere/subscriptions',
		organizations_url: 'https://api.github.com/users/vincent-souchiere/orgs',
		repos_url: 'https://api.github.com/users/vincent-souchiere/repos',
		events_url:
			'https://api.github.com/users/vincent-souchiere/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/vincent-souchiere/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'Matthieu-Mary',
		id: 83779030,
		node_id: 'MDQ6VXNlcjgzNzc5MDMw',
		avatar_url: 'https://avatars.githubusercontent.com/u/83779030?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/Matthieu-Mary',
		html_url: 'https://github.com/Matthieu-Mary',
		followers_url: 'https://api.github.com/users/Matthieu-Mary/followers',
		following_url:
			'https://api.github.com/users/Matthieu-Mary/following{/other_user}',
		gists_url: 'https://api.github.com/users/Matthieu-Mary/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/Matthieu-Mary/starred{/owner}{/repo}',
		subscriptions_url:
			'https://api.github.com/users/Matthieu-Mary/subscriptions',
		organizations_url: 'https://api.github.com/users/Matthieu-Mary/orgs',
		repos_url: 'https://api.github.com/users/Matthieu-Mary/repos',
		events_url: 'https://api.github.com/users/Matthieu-Mary/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/Matthieu-Mary/received_events',
		type: 'User',
		site_admin: false,
	},
	{
		login: 'v-andreeva',
		id: 92911377,
		node_id: 'U_kgDOBYm3EQ',
		avatar_url: 'https://avatars.githubusercontent.com/u/92911377?v=4',
		gravatar_id: '',
		url: 'https://api.github.com/users/v-andreeva',
		html_url: 'https://github.com/v-andreeva',
		followers_url: 'https://api.github.com/users/v-andreeva/followers',
		following_url:
			'https://api.github.com/users/v-andreeva/following{/other_user}',
		gists_url: 'https://api.github.com/users/v-andreeva/gists{/gist_id}',
		starred_url:
			'https://api.github.com/users/v-andreeva/starred{/owner}{/repo}',
		subscriptions_url: 'https://api.github.com/users/v-andreeva/subscriptions',
		organizations_url: 'https://api.github.com/users/v-andreeva/orgs',
		repos_url: 'https://api.github.com/users/v-andreeva/repos',
		events_url: 'https://api.github.com/users/v-andreeva/events{/privacy}',
		received_events_url:
			'https://api.github.com/users/v-andreeva/received_events',
		type: 'User',
		site_admin: false,
	},
]
